import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar         from "./components/Navbar";
import Footer         from "./components/Footer";
import Home           from "./pages/Home";
import OurWhy         from "./pages/OurWhy";
import Services       from "./pages/Services";
import Team           from "./pages/Team";
import Clients        from "./pages/Clients";
import Testimonials   from "./pages/Testimonials";
import Podcast        from "./pages/Podcast";
import HealthArchive  from "./pages/HealthArchive";
import Contact        from "./pages/Contact";
import AdminLogin     from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Unsubscribe   from "./pages/Unsubscribe";

function PrivateRoute({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#0B0B0B" }}>
      <p style={{ color:"rgba(255,255,255,0.4)", fontFamily:"var(--font)" }}>Loading…</p>
    </div>
  );
  return admin ? children : <Navigate to="/admin" replace />;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"              element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/our-why"       element={<PublicLayout><OurWhy /></PublicLayout>} />
          <Route path="/services"      element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/team"          element={<PublicLayout><Team /></PublicLayout>} />
          <Route path="/clients"       element={<PublicLayout><Clients /></PublicLayout>} />
          <Route path="/testimonials"  element={<PublicLayout><Testimonials /></PublicLayout>} />
          <Route path="/podcast"       element={<PublicLayout><Podcast /></PublicLayout>} />
          <Route path="/health-archive"element={<PublicLayout><HealthArchive /></PublicLayout>} />
          <Route path="/contact"       element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/unsubscribe"   element={<Unsubscribe />} />
          <Route path="/admin"         element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
          <Route path="*"              element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
